import { useTranslation } from "react-i18next";
import type { CustomerClass } from "@hisense/shared";
import { Badge } from "@/components/ui/Badge";

/**
 * Đội của một nhà cung cấp (29/09/2026) — cùng kiểu nhãn với phân loại khách. "Chưa phân loại" mang màu cảnh báo: nhà cung cấp
 * đó cả hai đội đều thấy cho tới khi có người chọn đội.
 */
export function SupplierRegionBadge({ classification }: { classification: CustomerClass | null }) {
  const { t } = useTranslation();
  if (!classification) return <Badge tone="warn" outline>{t("suppliers.unclassified")}</Badge>;
  return (
    <Badge tone={classification === "china" ? "info" : "neutral"} outline>
      {t(classification === "china" ? "suppliers.china" : "suppliers.vietnam")}
    </Badge>
  );
}
